import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

function DraftTerms() {
  const [doc, setDoc] = useState(null);
  const [open, setOpen] = useState(false);
  const show = () => { setOpen(true); if (!doc) api.get("/merchant/sponsored-cashback/terms-draft").then((r) => setDoc(r.data)).catch(() => setDoc({ sections: [] })); };
  return (
    <>
      <button onClick={show} className="pf-btn-glass px-4 py-2 rounded-full text-sm font-semibold" data-testid="sc-terms-draft-btn">Read the draft terms</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="sc-terms-draft-dialog">
          <DialogHeader>
            <DialogTitle>{doc?.title || "Draft terms"}</DialogTitle>
            <DialogDescription className="font-semibold text-amber-700" data-testid="sc-terms-draft-label">DRAFT FOR LEGAL REVIEW — not approved and not in effect.</DialogDescription>
          </DialogHeader>
          {(doc?.sections || []).map((s, i) => (
            <div key={s.title} className="space-y-2" data-testid={`sc-terms-section-${i}`}>
              <h4 className="font-semibold text-slate-900">{i + 1}. {s.title}</h4>
              {s.paragraphs.map((p) => <p key={p.slice(0, 40)} className="text-sm text-slate-700 leading-relaxed">{p}</p>)}
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
}

export function PolicyCard({ policy }) {
  return (
    <section className="pf-card p-6 space-y-3" data-testid="sc-policy-card">
      <div className="flex flex-wrap items-center gap-2">
        <h3 className="font-display text-xl font-medium text-slate-900">Cyannect Performance Fee and refunds</h3>
        <span className="pf-chip" data-testid="sc-policy-status">Draft for legal review</span>
      </div>
      {policy?.summary && <p className="text-sm text-slate-700 max-w-3xl" data-testid="sc-policy-summary">{policy.summary}</p>}
      <p className="text-sm text-slate-600">Funding Sponsored Cashback never changes the Cyannect Performance Fee on any sale.</p>
      <div className="flex flex-wrap gap-2 pt-1">
        <DraftTerms />
        {policy?.enabled && <Link to="/merchant/cashback" className="pf-btn-glass px-4 py-2 rounded-full text-sm font-semibold" data-testid="sc-fee-review-link">Ask Cyannect to review a fee</Link>}
      </div>
    </section>
  );
}
